import { useState } from 'react';
import tw, { styled } from 'twin.macro';
import 'styled-components/macro';

const Wrapper = styled.div`
  width: 100%;
  min-height: 80px;
  ${tw`bg-green`};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
  z-index: 1;
`;

const Messages = styled.div`
  padding: 15px 40px 0;
`;

const Title = styled.span`
  font-size: 16px;
  line-height: 28px;
  font-weight: 600;
  ${tw`text-white`}
  display: block;
`;

const Subtitle = styled.span`
  font-size: 15px;
  line-height: 18px;
  font-weight: 400;
  ${tw`text-white`}
  display: block;
`;

interface ProgressBarProps {
  running: boolean;
}

const ProgressBar = styled.div<ProgressBarProps>`
  width: 100%;
  height: 5px;
  opacity: 0.8;
  animation: challenge-completion 5s linear 1;
  animation-play-state: ${props => (props.running ? 'running' : 'paused')};
  background: rgba(0, 0, 0, 0.25);
  justify-self: flex-end;

  @keyframes challenge-completion {
    0% {
      width: 100%;
    }
    100% {
      width: 0;
    }
  }
`;

export interface CompletionBannerProps {
  subtitle: string;
  onComplete?(): void;
}

const CompletionBanner = ({ subtitle, onComplete = () => {} }: CompletionBannerProps) => {
  const [running, setRunning] = useState(true);

  const pauseProgressBar = () => setRunning(false);
  const playProgressBar = () => setRunning(true);

  return (
    <Wrapper onMouseEnter={pauseProgressBar} onMouseLeave={playProgressBar} onClick={onComplete}>
      <div>
        <Messages>
          <Title>Well done!</Title>
          <Subtitle>{subtitle}</Subtitle>
        </Messages>
      </div>
      <ProgressBar running={running} onAnimationEnd={onComplete} />
    </Wrapper>
  );
};

export default CompletionBanner;
